import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FonepayLogo from "../../../assets/img/payment/Fonepay.png";
import { Modal } from "react-bootstrap";
import CartTable from "./CartTable";
import CartChangeTable from "./CartChangeTable";
import CartMergeTable from "./CartMergeTable";
import ApiConnect from "../../../Utils/ApiConnect";
import {
  AddMembership,
  RefreshTable,
} from "../../../redux/actions/Cart.Action";
class CartHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartModal: false,
      tableChgModal: false,
      mergeTableModal: false,
      memberModal: false,
      membershipNumber: "",
    };
  }
  fetchMemberShipDetails = (e) => {
    e.preventDefault();
    ApiConnect.get(
      `/Members/Information/CustomerList?id=${this.state.membershipNumber}`
    ).then((response) => {
      if (response.status === 200) {
        this.props.AddMembership(response.data.data);
        this.setState({ membershipNumber: "" });
      }
    });
  };
  render() {
    const CurrentCart = this.props.CurrentCart;
    return (
      <>
        <div className="card shadow-sm">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-4">
                <div
                  className="cart d-flex align-items-center"
                  onClick={() => {
                    if (!this.props.LockScreen) {
                      this.setState({ cartModal: true });
                    }
                  }}
                >
                  <span className="material-icons-outlined icon">deck</span>
                  <div>
                    <span className="subtitle">Table No:</span>
                    <span className="title">
                      {CurrentCart ? CurrentCart.table : ""}
                      {this.state.payment ? (
                        <img src={FonepayLogo} width="70" alt="fonepay" />
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div
                  className="cart d-flex"
                  onClick={() => {
                    if (CurrentCart.length !== 0) {
                      this.setState({ memberModal: true });
                    }
                  }}
                >
                  <span className="material-icons-outlined icon">people</span>
                  <div className="">
                    <span className="subtitle">Customers</span>
                    <span
                      className=""
                      style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                    >
                      {CurrentCart
                        ? CurrentCart.membership
                          ? CurrentCart.membership.name
                          : ""
                        : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="cart d-flex">
                  <span className="material-icons-outlined icon">people</span>
                  <div className="overflow-hidden">
                    <span className="subtitle">Waiter</span>
                    <span
                      className=""
                      style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                    >
                      {CurrentCart ? CurrentCart.waiter : ""}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.memberModal}
          className="modal-center"
          size="md"
          onHide={() => this.setState({ memberModal: false })}
        >
          <Modal.Header className="mb-0 pb-0">Membership</Modal.Header>
          <Modal.Body>
            <div className="">
              {CurrentCart.length !== 0 ? (
                CurrentCart.membership.length !== 0 ? (
                  <address>
                    <b>Name</b>
                    <br />
                    <p>{CurrentCart.membership.name}</p>
                    <br />
                    <b>Reward Points</b>
                    <br />
                    <p>{CurrentCart.membership.reward_point}</p>
                    <br />
                    <b>Total Orders</b>
                    <br />
                    <p>{CurrentCart.membership.total_order}</p>
                  </address>
                ) : (
                  <>
                    <form onSubmit={(e) => this.fetchMemberShipDetails(e)}>
                      <input
                        type={"number"}
                        className="form-control"
                        onChange={(e) =>
                          this.setState({ membershipNumber: e.target.value })
                        }
                      />
                      <button className="btn btn-success" type="submit">
                        Add
                      </button>
                    </form>
                  </>
                )
              ) : (
                ""
              )}
            </div>
            <div className=""></div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.cartModal}
          className="modal-center"
          size="md"
          onHide={() => this.setState({ cartModal: false })}
        >
          <Modal.Header className="mb-0 pb-0">
            <h5 className="modal-title">Select Table</h5>
            <div className="btn-group">
              <button
                className="btn btn-success no-radius btn-sm"
                onClick={() => this.props.RefreshTable()}
              >
                <span className="material-icons-outlined">refresh</span>
              </button>
              <button
                className="btn btn-purple no-radius btn-sm"
                disabled={CurrentCart.length === 0 ? true : false}
                onClick={() => this.setState({ tableChgModal: true })}
              >
                <span className="material-icons-outlined">
                  published_with_changes
                </span>
              </button>
              <button
                className="btn btn-brown no-radius btn-sm"
                disabled={CurrentCart.length === 0 ? true : false}
                onClick={() => this.setState({ mergeTableModal: true })}
              >
                <span className="material-icons-outlined">merge</span>
              </button>
              <Modal
                show={this.state.tableChgModal}
                className="modal-center"
                size="md"
                onHide={() => this.setState({ tableChgModal: false })}
              >
                <Modal.Header className="mb-0 pb-0">
                  <h5 className="modal-title">Change Table</h5>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <CartChangeTable />
                </Modal.Body>
              </Modal>
              <Modal
                show={this.state.mergeTableModal}
                className="modal-center"
                size="md"
                onHide={() => this.setState({ mergeTableModal: false })}
              >
                <Modal.Header className="mb-0 pb-0">
                  <h5 className="modal-title">Merge Table</h5>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <CartMergeTable />
                </Modal.Body>
              </Modal>
            </div>
          </Modal.Header>
          <Modal.Body className="p-0">
            <CartTable />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    LockScreen: state.Auth.lockScreen,
  }),
  { AddMembership, RefreshTable }
)(withRouter(React.memo(CartHeader)));
